import { render, staticRenderFns } from "./array-table-field-modal.vue?vue&type=template&id=05cba9c0&scoped=true"
import script from "./array-table-field-modal.vue?vue&type=script&lang=js"
export * from "./array-table-field-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cba9c0",
  null
  
)

export default component.exports